import FacebookLoginButton from "./FacebookLoginButton";

export default FacebookLoginButton;